<section>
  <div class="div-loading">
    @if (erroLoading) {
      <div class="div-button-close">
        <button class="button-close-loading" [mat-dialog-close]>
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
    @if (erroLoading) {
      <div class="loading-img erro">
        <img src="/assets/img/erro-alerta.svg" alt="alerta">
      </div>
    }
    @if (title) {
      <p class="loading-title">{{ title }}</p>
    }
    @if (firstText) {
      <p class="loading-text loading-font-14" style="margin-bottom: 0;" [innerHTML]="firstText | sanitizerHtml"></p>
    }
    @if (secondText) {
      <p class="loading-text loading-font-14" [innerHTML]="secondText | sanitizerHtml"></p>
    }
    @if (textButton) {
      <div class="text-center div-button-text">
        <button class="button-text botao-outline" [mat-dialog-close]="textButton">{{ textButton }}</button>
      </div>
    }
    @if (!erroLoading) {
      <div>
        <div class="loading-img">
          <img src="/assets/img/loading-vt.gif" alt="Loading">
        </div>
        <p class="loading-wait loading-font-14">Por favor, aguarde...</p>
      </div>
    }
  </div>
</section>
